import ExpandableRow from './ExpandableRow';
import expandableRowStyles from './expandableRow.module.scss';

export { ExpandableRow, expandableRowStyles };

export default ExpandableRow;
